export default {
  image: 'A2_2.png',
  pdf: '220922_WA-OWDVS_001_A2_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-OWDVS-001',
    technicalValues: {
      soundReductionIndex: {
        output: '44,0',
        value: 44
      },
      heatTransferCoefficient: {
        output: '0,38',
        value: 0.38
      },
      fireResistanceOuter: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      fireBehavior: {
        output: 'keine Angabe',
        value: null
      },
    },
    name: 'Wandaufbau ohne WDVS l Aufbau 1',
    construction: {
      composition: [
        {
          output: 'ohne',
          type: 'render',
          title: { de: 'Putz' },
          value: null
        },
        {
          output: 'keine',
          type: 'pinsulation', 
          title: { de: 'Dämmung' },
          value: null
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '≥ 60/100',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-100'
        },
        {
          output: '100 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: 'keine',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: null
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '125',
        value: 125
      }
    }
  }
}
